
import * as d3 from 'd3'  
export function ForceGraph({
        nodes, // an iterable of node objects (typically [{id}, …])
        links // an iterable of link objects (typically [{source, target}, …])
    }, 
    {
        nodeId = d => d.id, // 给定节点中的d，返回唯一标识符(字符串)
        nodeGroup, // 给定节点数d，返回color的(序数)值
        nodeGroups, // 节点组的序数值的数组
        nodeTitle, // 节点名称
        nodeFill = "currentColor", // 节点描边填充(如果不使用组颜色编码)
        nodeStroke = "#fff", // 节点描边颜色
        nodeStrokeWidth = 1.5, // 节点描边宽度，以像素为单位
        nodeStrokeOpacity = 1, // 节点描边不透明度
        nodeRadius = 5, // 节点半径，单位为像素
        nodeStrength,
        linkSource = ({source}) => source, // 链接中的d，返回一个节点标识符字符串
        linkTarget = ({target}) => target, // 给定链接中的d，返回一个节点标识符字符串
        linkStroke = "#999", // 线选中颜色
        linkStrokeOpacity = 0.6, // 线选中 opacity
        linkStrokeWidth = 1.5, // 线的宽度
        linkStrokeLinecap = "round", // link stroke linecap
        linkStrength,
        colors = d3.schemeTableau10, // 一个颜色字符串数组，用于节点组。
        width = 640, // outer width, in pixels
        height = 400, // outer height, in pixels
        invalidation, // when this promise resolves, stop the simulation
        lineLength = 1,
    } = {}) {  
        // console.log(lineLength,width,'=')
        const N = d3.map(nodes, nodeId).map(intern);
        const LS = d3.map(links, linkSource).map(intern);
        const LT = d3.map(links, linkTarget).map(intern);
        if (nodeTitle === undefined) nodeTitle = (_, i) => N[i];
        const T = nodeTitle == null ? null : d3.map(nodes, nodeTitle);
        const G = nodeGroup == null ? null : d3.map(nodes, nodeGroup).map(intern);
        const W = typeof linkStrokeWidth !== "function" ? null : d3.map(links, linkStrokeWidth);
        const L = typeof linkStroke !== "function" ? null : d3.map(links, linkStroke);
        // Replace the input nodes and links with mutable objects for the simulation.
        nodes = d3.map(nodes, (_, i) => ({id: N[i]}));
        links = d3.map(links, (_, i) => ({source: LS[i], target: LT[i]}));
    
        // Compute default domains.
        if (G && nodeGroups === undefined) nodeGroups = d3.sort(G);
    
        // 构建尺度 colors可重新自定义.
        const color = nodeGroup == null ? null : d3.scaleOrdinal(nodeGroups, colors);
        // 力导图.
        const forceNode = d3.forceManyBody();
        // const forceLink = d3.forceLink(links).id(({index: i}) => N[i])
        const forceLink = d3.forceLink(links).id(({index: i}) => N[i]).distance(lineLength*100);
        if (nodeStrength !== undefined) forceNode.strength(nodeStrength);
        if (linkStrength !== undefined) forceLink.strength(linkStrength);
    
        const simulation = d3.forceSimulation(nodes)
            .force("link", forceLink)
            .force("charge", forceNode)
            .force("center",  d3.forceCenter())
            .on("tick", ticked)
            //.distance(lineLength * 5)//设置或获取两个节点之间的距离)
    
        const svg = d3.create("svg")
            .attr("id", '#d3svg')
            .attr("width", width)
            .attr("height", height)
            .attr("viewBox", [ -width / 2, -height / 2, width, height])// -580,-370,1160,740 -width / 2, -height / 2, width, height
            .attr("style", "max-width: 100%; height: auto; height: intrinsic;") 
            .call(zoom(simulation));
    
        const link = svg.append("g")
            .attr('class','links')
            .attr("stroke", typeof linkStroke !== "function" ? linkStroke : null)
            .attr("stroke-opacity", linkStrokeOpacity)
            .attr("stroke-width", typeof linkStrokeWidth !== "function" ? linkStrokeWidth : null)
            .attr("stroke-linecap", linkStrokeLinecap) 
            .selectAll("line") 
            .data(links)
            .join("line");
            
    
        const node = svg.append("g")
            .attr('class','nodes')
            .attr("fill", nodeFill)
            .attr("stroke", nodeStroke)
            .attr("stroke-opacity", nodeStrokeOpacity)
            .attr("stroke-width", nodeStrokeWidth)
            .selectAll("circle")
            .data(nodes) 
            .join("circle")
            .attr("r", nodeRadius)
            // .attr("transform", transform1)
            .call(drag(simulation));
            //.call(zoom(simulation));
    
        if (W) link.attr("stroke-width", ({index: i}) => W[i]);
        if (L) link.attr("stroke", ({index: i}) => L[i]);
        if (G) node.attr("fill", ({index: i}) => color(G[i]));
        if (T) node.append("title").text(({index: i}) => T[i]);
        if (invalidation != null) invalidation.then(() => simulation.stop());
    
        const nodeNameText=svg.append("g")
            .attr('class','nodeText')
            .selectAll('text')
            .data(nodes)
            .join('text')
            .attr('dx','6')
            .attr('dy','4')
            // .attr("transform", transform2)
            .attr('class','node-name')
            .text(function(d){
                return d.id
            })   
        function intern(value) {
        return value !== null && typeof value === "object" ? value.valueOf() : value;
        }
    
        function ticked() {
            link
                .attr("x1", d => d.source.x) 
                .attr("y1", d => d.source.y)
                .attr("x2", d => d.target.x)
                .attr("y2", d => d.target.y);
        
            node
                .attr("transform", function(d) {
                    var cx = d.x;
                    var cy = d.y;
                    return "translate(" + cx + "," + cy + ")";
                }); 
                
            nodeNameText
                .attr("x", d => d.x)
                .attr("y", d => d.y)

        } 

        function zoom(simulation){//缩放函数  
            function zoomed ({transform}) {
                let g = d3.selectAll('g')
                g.attr("transform", transform);
              }
            return d3.zoom()  
                .extent([[0, 0], [ 1160, 740]])
                .scaleExtent([.3, 8]) // zoom limit 
                .on("zoom", zoomed); 
        }
         
        function drag(simulation) {  
            function dragstarted(event) {
                if (!event.active) simulation.alphaTarget(0.3).restart();
                
                event.subject.fx = event.subject.x;
                event.subject.fy = event.subject.y;
            }
            
            function dragged(event) {  
                event.subject.fx = event.x;
                event.subject.fy = event.y ;  

            }
            
            function dragended(event) {
                if (!event.active) simulation.alphaTarget(0);
                event.subject.fx = null;
                event.subject.fy = null;
            }
            return d3.drag()
                .on("start", dragstarted)
                .on("drag", dragged)
                .on("end", dragended) 
        }
    return Object.assign(svg.node(), {scales: {color}});
}
